import React from 'react';
import Icon from '@pushpay/icon';

const LockIcon = props => {
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.316 9.917h-.632V7.625C17.684 4.518 15.14 2 12 2 8.86 2 6.316 4.518 6.316 7.625v2.292h-.632c-.93 0-1.684.745-1.684 1.666v8.75C4 21.254 4.754 22 5.684 22h12.632c.93 0 1.684-.746 1.684-1.667v-8.75c0-.92-.754-1.666-1.684-1.666zm-8 5a1.675 1.675 0 011.676-1.675 1.675 1.675 0 011.692 1.66 1.663 1.663 0 01-.842 1.45v1.898c0 .46-.377.833-.842.833a.838.838 0 01-.842-.833v-1.898a1.658 1.658 0 01-.842-1.435zM8.42 7.625c0-1.956 1.603-3.542 3.579-3.542 1.976 0 3.579 1.586 3.579 3.542V9.5c0 .23-.189.417-.421.417H8.842a.419.419 0 01-.42-.417V7.625z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

export default LockIcon;